export { BannerWithAsset } from './BannerWithAsset';
